import { ModulePermissions, PermissionsPipeData } from "./base-classes";
import * as R from 'ramda'
import { LoggedUser } from "../../../redux/store";
import {Account} from "@idha/idha-types"

export class AreaSchedulingAccessPermissions extends ModulePermissions {
    showMySchedules:boolean

    constructor() {
        super()
    }
}

export class AreaSchedulingPermissionsPipeData extends PermissionsPipeData<AreaSchedulingAccessPermissions> {

    
    constructor(loggedUser:LoggedUser,public account:Account){
        super(loggedUser,new AreaSchedulingAccessPermissions());
        
    }
}

namespace AccessRules {
    export function areaSchedulingUser(data:AreaSchedulingPermissionsPipeData):AreaSchedulingPermissionsPipeData {
        // quando elaborar as permissoes do AreaScheduling analisar 
        //const isAreaSchedulingUser = data.account?.areaSchedulingAccountType != null
        const isAreaSchedulingUser = false
        return { 
                ...data,
                permissions: {
                    showMySchedules: isAreaSchedulingUser
                }
            }   
    }

    export function end(data:AreaSchedulingPermissionsPipeData):AreaSchedulingAccessPermissions {
        return data.permissions
    }
}

export default R.pipe(
    AccessRules.areaSchedulingUser,
    AccessRules.end
)

